<template>
	<div v-if="location" class="grow flex items-center gap-3">
		<CountryFlag :iso="location.country.code" mode="rounded"/>
		<div class="flex flex-col items-start">
			<p class="text-sm uppercase font-bold"><slot/></p>
			<p>{{ locationFullName }}</p>
			<p class="text-gray-400 text-sm">{{ coordinates(location.lat, location.long) }}</p>
		</div>
	</div>
</template>
<script setup lang="ts">
import {coordinates} from '@/helpers'
import {type Location} from '@/Types/Location'
import CountryFlag from '@dzangolab/vue-country-flag-icon'
import {computed, type ComputedRef, defineProps, ref, type Ref} from 'vue'

const props = defineProps<{
	location?:Location,
}>()

const location:Ref<Location|undefined> = ref(props.location)

const locationFullName:ComputedRef<string> = computed(():string => {
	if(location.value){
		if(location.value.region){
			return `${location.value.name}, ${location.value.region.name}, ${location.value.country.name}`
		}
		return `${location.value.name}, ${location.value.country.name}`
	}
	return ''
})
</script>
